<div id="page-wrapper" class="page-wrapper" *mobxAutorun>
    <dashboard-nav id="overview-header" [user]="store?.user" [student]="student?.student"
        (onSignOut)="store?.signOut()">
    </dashboard-nav>
    <router-outlet></router-outlet>
</div>